import React, { useState } from 'react';
import { CFormTextarea, CFormLabel, CBadge, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react';
import { Edit2, X } from 'lucide-react';
import SuggestionCopy from './SuggestionCopy';

const ResonSuggestion = ({ keywords, setKeywords, label = "Keywords" }) => {

    const [textInput, setTextInput] = useState('');
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [activeTab, setActiveTab] = useState(0);

    const handleInputChange = (event) => {
        setTextInput(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && textInput.trim()) {
            event.preventDefault();
            const newKeyword = textInput.trim();
            setKeywords([...keywords, newKeyword]);
            setTextInput('');
            // if (editMode) setEditMode(false);
        }
    };

    const handleEditKeyword = (index) => {
        const selectedKeyword = keywords[index];
        setTextInput(selectedKeyword);
        setKeywords(keywords.filter((_, i) => i !== index));
        setEditMode(true);
    };

    const handleRemoveKeyword = (index) => {
        setKeywords(keywords.filter((_, i) => i !== index));
    };

    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (event, index) => {
        event.preventDefault();
        if (index === draggedIndex) return;

        const reordered = Array.from(keywords);
        const [draggedItem] = reordered.splice(draggedIndex, 1);
        reordered.splice(index, 0, draggedItem);
        setKeywords(reordered);
        setDraggedIndex(index);
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
    };

    return (
        <div className=''>
            <div>
                <CFormLabel>{label}</CFormLabel>
                <CFormTextarea
                    type="text"
                    placeholder={"Type and press enter to add " + label}
                    value={textInput}
                    onChange={handleInputChange}
                    onKeyPress={handleKeyPress}
                    name="assessment"
                    rows={1}
                />
                <div
                    style={{
                        marginTop: '10px',
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    {Array.isArray(keywords) && keywords?.map((keyword, index) => (
                        <CBadge
                            key={index}
                            color="primary"
                            className="me-1 p-2"
                            draggable
                            onDragStart={() => handleDragStart(index)}
                            onDragOver={(event) => handleDragOver(event, index)}
                            onDragEnd={handleDragEnd}
                            style={{
                                cursor: 'grab',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                width: 'fit-content',
                            }}
                        >
                            <span>{keyword}</span>
                            <Edit2
                                size={12}
                                style={{
                                    cursor: 'pointer',
                                    color: 'yellow',
                                    marginLeft: '5px',
                                    marginRight: '2px',
                                }}
                                onClick={() => handleEditKeyword(index)}
                                className="text-white"
                            />
                            <X
                                className="text-white"
                                size={12}
                                style={{ cursor: 'pointer', color: 'red' }}
                                onClick={() => handleRemoveKeyword(index)}
                            />
                        </CBadge>
                    ))}
                </div>
            </div>
        </div>

    );
};

export default ResonSuggestion;
